var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 18.5454,
    width: 24,
    height: 2.18182,
    fill: "#394577"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09106 3.2727L12.0002 -3.05176e-05V18.5454H1.09106V3.2727Z",
    fill: "#394577"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0908 4.36359H22.909V18.5454H13.0908V4.36359Z",
    fill: "#394577"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.45459,
    y: 4.36359,
    width: 2.18182,
    height: 2.18182,
    fill: "#F0F2F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9216,
    y: 5.98807,
    width: 2.18182,
    height: 2.18182,
    fill: "#F0F2F9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.45459,
    y: 9.27271,
    width: 2.18182,
    height: 2.18182,
    fill: "#F0F2F9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9089,
    y: 10.3636,
    width: 2.18182,
    height: 2.18182,
    fill: "#F0F2F9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.45459,
    y: 13.6075,
    width: 2.18182,
    height: 2.18182,
    fill: "#F0F2F9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16.9089,
    y: 15.1921,
    width: 2.18182,
    height: 2.18182,
    fill: "#F0F2F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrg);
export default __webpack_public_path__ + "static/media/org.ee2592cd79763de9e05180ea7ef42c56.svg";
export { ForwardRef as ReactComponent };